import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrMedicalChartIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M13.2239 1H6.95522H2.77612C1.83582 1 1 1.83582 1 2.77612V13.2239C1 14.1642 1.83582 15 2.77612 15H6.95522H13.2239C14.1642 15 15 14.1642 15 13.2239V2.77612C15 1.83582 14.1642 1 13.2239 1ZM13.2239 2.46269C13.4328 2.46269 13.5373 2.56716 13.5373 2.77612V5.70149H12.4925C11.9701 5.70149 11.4478 6.01493 11.3433 6.53731L11.1343 7.26866L10.6119 4.55224C10.5075 4.02985 10.0896 3.61194 9.46269 3.50746C8.9403 3.40299 8.41791 3.71642 8.20896 4.34328L7.58209 5.70149H6.64179V2.77612C6.64179 2.56716 6.74627 2.46269 6.95522 2.46269H13.2239ZM2.46269 13.2239V2.77612C2.46269 2.56716 2.56716 2.46269 2.77612 2.46269H5.1791C5.1791 2.56716 5.1791 2.67164 5.1791 2.77612V13.2239C5.1791 13.3284 5.1791 13.4328 5.1791 13.5373H2.77612C2.56716 13.5373 2.46269 13.4328 2.46269 13.2239ZM13.2239 13.5373H6.95522C6.74627 13.5373 6.64179 13.4328 6.64179 13.2239V7.16418H7.79105C8.31343 7.16418 8.73134 6.85075 8.9403 6.32836L9.25373 5.49254L9.77612 8.31343C9.8806 8.83582 10.2985 9.25373 10.9254 9.35821H11.0299C11.5522 9.35821 11.9701 9.04478 12.1791 8.52239L12.7015 7.16418H13.5373V13.2239C13.5373 13.4328 13.4328 13.5373 13.2239 13.5373Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrMedicalChartIconComponent;
